<!-- use soho-checkbox so we can manually update selected/unselected -->
@if (isSelectable) {
  <div class="checkbox-container">
    <input attr.data-automation-id="{{blockItemCheckboxAutomationId}}" soho-checkbox [checked]="selected ? selected : null" #Checkbox type="checkbox" aria-hidden="true" role="presentation" class="checkbox" tabindex="0">
    <label [ngStyle]="{'display':  checkboxIsVisible ? 'block' : 'none' }" class="checkbox-label" (click)="selected ? unSelectItem($event) : selectItem($event)"><span class="audible">Select</span></label>
  </div>
}

<div
  #Block
  [ngClass]="{'block': true, 'is-horizontal': isHorizontal}" role="listitem" tabindex="0"
  (dblclick)="doubleClick()"
  (contextmenu)="onContextMenu($event)"
  (click)="isHorizontal ? selectItem($event) : activateRow($event)"
  >
  @if (content === 'image-item') {
    @if (data.foregroundText) {
      <span class="image-initials large {{data.bgClass}}">{{data.foregroundText}}</span>
    }
    <img alt="{{data.itemText}}" src="{{data.imageUrl}}" class="profileImage" soho-tooltip [popover]="true" [content]="tooltip" [placement]="'right'">
    <div style="display: inline-block; width: 100%">
      <ng-container [ngTemplateOutlet]="data.dataView.doesNotExist ? DoesNotExist : ImageContent"></ng-container>
    </div>
    <ng-template #ImageContent>
      <p style="font-size:1.4rem; text-overflow: ellipsis; width: 95px; overflow: hidden;">{{data.itemText}}</p>
    </ng-template>
    <ng-template #DoesNotExist>
      <del>
        <p style="font-size:1.4rem; text-overflow: ellipsis; width: 95px; overflow: hidden;">{{data.itemText}}</p>
      </del>
    </ng-template>
  }
  @if (content === 'sectioned-card') {
    <ng-content select="[content]"></ng-content>
  }
</div>

